import {push} from "connected-react-router";
import {ADV_LOGIN_ROUTE} from "../components/Root/routes";
import {RESET_DATA} from "../types";
import {callURL} from "./call";
import {signerURL} from "../url";

const logout= () => async (dispatch) =>
{
    const onResult= () =>
    {
        dispatch({type:RESET_DATA});
        dispatch(push(ADV_LOGIN_ROUTE));
    }
    dispatch(callURL(signerURL,"rest/LoginService/logoutUser", {},onResult));
};
export default logout;